import { Component, OnInit, Input, Inject, PLATFORM_ID, AfterViewInit, ElementRef, ViewChild  } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { CustomDeviceDetectorService } from '../../services/CustomDeviceDetectorService';
import { isPlatformServer } from '@angular/common';
import Swiper from 'swiper';
import { ICardProductDataModel } from '../../models/card-product.datamodel';

@Component({
  selector: 'app-card-products-module',
  templateUrl: './card-products-module.component.html',
  // styleUrls: ['./card-products-module.component.css']
})
export class CardProductsModuleComponent implements OnInit, AfterViewInit {
  @Input() rendering: ComponentRendering;
  @ViewChild('CardProductsModuleSlider', { static : false}) swiperSlider!: ElementRef;
  jssStylingService: JssStylingService;
  dynamicClass: string;
  devicedetectorService: CustomDeviceDetectorService;
  isMobile: boolean;
  swiper: Swiper;
  _isPlatformServer: boolean = false;
  cards: ICardProductDataModel[] = [];

  constructor(jssStylingService: JssStylingService,
    devicedetectorService: CustomDeviceDetectorService,
    @Inject(PLATFORM_ID) public readonly platformId: string,
    ) { 
    this.jssStylingService = jssStylingService;
    this.devicedetectorService = devicedetectorService;
    platformId 
  }

  ngOnInit() {
    this._isPlatformServer = isPlatformServer(this.platformId);
    // remove this after implementation is done
    console.log('CardProductsModule component initialized with component data', this.rendering);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.isMobile = this.devicedetectorService.isMobile();

    if((this.rendering.fields.Cards as any)?.length > 0){ 
      for (let i = 0; i < (this.rendering.fields.Cards as any)?.length; i++) {
        let card:ICardProductDataModel = {
          Title: (this.rendering.fields.Cards as any)[i]?.fields?.Title?.value,
          Description: (this.rendering.fields.Cards as any)[i]?.fields?.Description?.value,
          Link: (this.rendering.fields.Cards as any)[i]?.fields?.Link.value
        } 
        this.cards.push(card);
      }
      this.cards = this.cards.map(card => ({ ...card }));
    }
  }

  ngAfterViewInit() {
    if(!this._isPlatformServer && this.isMobile){
      this.swiper = new Swiper(this.swiperSlider.nativeElement, {
        spaceBetween: 24,
        freeMode: true,
        grabCursor: true,
        centeredSlides: false,
        slidesPerView: 'auto',
        // breakpoints: {
        //   1024: {
        //     enabled: false,
        //     spaceBetween: 0,
        //   }
        // }
      });
    }
  }
}
